import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React from 'react';
import classnames from 'classnames';
import useLegacyProps from '../../hooks/useLegacyProps.js';

var _excluded = ["children", "fluid", "theme", "size"];
var _templateObject;
var StyledContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @media (min-width: 1200px) {\n    &&& {\n      width: ", ";\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  return theme.grid.containerWidth[size];
});
var Container = function Container(_ref2) {
  var children = _ref2.children,
    fluid = _ref2.fluid,
    _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? themes["default"] : _ref2$theme,
    size = _ref2.size,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var _useLegacyProps = useLegacyProps(rest),
    className = _useLegacyProps.className,
    style = _useLegacyProps.style;
  var classes = classnames({
    container: !fluid,
    'container-fluid': fluid
  }, className);
  return /*#__PURE__*/React.createElement(StyledContainer, _extends({}, rest, {
    className: classes,
    style: style,
    theme: theme,
    size: size
  }), children);
};

export default Container;
